<template>
    <div>
        <h1 
            class="fs-4 fw-bold text-dark mb-1 lh-sm"
        >
            Reglas de visibilidad
        </h1>
        <p
            class="text-muted small fw-medium "
        >
            Define la visibilidad de los productos. Los SKUs serán marcados según su configuración de visibilidad.
        </p>
        <TableVisibilityConfig 
            @getData="getSearch"
            @change-page="changePage"
            @change-page-size="changePageSize"
            @viewModal="viewModal"
            :products="productList"
            :loading="loading"
            :total-count="totalProducts"
            :current-page="currentPage"
            :page-size="pageSize"
        />
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="componentName" :propHead="propHead" @refrest="refrest" @closeModal="closeModal"/>
            </template>
        </modal-form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import configsRecModuleMixin from '../mixins/configsRecModuleMixin';
import TableVisibilityConfig from './TableVisibilityConfig.vue';
import ModalForm from "../../../../../components/modal.vue";
import ConfigVisibilityOne from './configVisibilityOne.vue';
import ConfigVisibilityGroup from './configVisibilityGroup.vue';
import ConfigVisibilityOptions from './configVisibilityOptions.vue';

export default {
    name: 'config-visibility',
    mixins: [configsRecModuleMixin],
    components: {
        TableVisibilityConfig,
        ModalForm,
        ConfigVisibilityOne,
        ConfigVisibilityGroup,
        ConfigVisibilityOptions
    },
    data() {
        return {
            propHead: {
                action: "",
                open: false,
                module: "visibility",
                text : ""
            },
            propForm: {
                size: "",
                form: "",
            },
            componentName: null,
        };
    },
    methods: {
        ...mapActions(["executeCommit"]),
        buildUrl() {
            return `/api/products/list_config_visibility/?${this.buildCommonParams()}&prop_extra_3=VIGENTE`;
        },
        viewModal(row,name,title,text) {
            this.componentName = name;
            this.propForm.size = false
            this.propHead = {
                action: title,
                open: true,
                row: row,
                text: text,
                component:this.componentName,
            }
        },
        closeModal() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.propHead = {
                action: "",
                open: false,
                module: "visibility",
                text: ""
            };
            this.componentName = null;
        },
        refrest() {
            this.closeModal();
            this.fetchData();
        },
    }
}
</script>
